import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { labels } from "../../../../lang/labels";
import { useSelector } from "react-redux";
import TextInput from "../../../form-fields/text-input";

const TransactionDetailsTable = ({ reviewData, handlePaidAmtChange }) => {
  // console.log("!!reviewData", reviewData);

  const {
    lblTotalAmt,
    lblIllegalFajil,
    lblFajilbal,
    lblConsAmt,
    lblBalanceAmount,
  } = reviewData;
  const lang = useSelector((state) => state.userDetails.lang);
  // console.log("!!labels.BillAmount", labels.BillAmount);
  return (
    <TableContainer>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow
            sx={{
              background: "#e6eaeb",
              "&:last-child td, &:last-child th": { border: 1 },
            }}
          >
            <TableCell align="center">{labels.BillAmount[lang]}</TableCell>
            <TableCell align="center">
              {labels.IllegalPropertyAdjustmentAmount[lang]}
            </TableCell>
            <TableCell align="center">{labels.ExtraPaidAmount[lang]}</TableCell>
            <TableCell align="center">
              {labels.ConcessionAmount[lang]}
            </TableCell>
            <TableCell align="center">{labels.PaidAmount[lang]} *</TableCell>
            <TableCell align="center">{labels.BalanceAmount[lang]}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 1 } }}>
            <TableCell align="center">{lblTotalAmt || "-"}</TableCell>
            <TableCell align="center">{lblIllegalFajil || "-"}</TableCell>
            <TableCell align="center">{lblFajilbal || "-"}</TableCell>
            <TableCell align="center">{lblConsAmt || "-"}</TableCell>
            <TableCell align="center">
              <TextInput
                name="txtPaidAmount"
                onChange={(e) => handlePaidAmtChange(e)}
                required
              />
            </TableCell>
            <TableCell align="center">{lblBalanceAmount}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionDetailsTable;
